import { ActionReducerMap } from '@ngrx/store';
import { forgotPasswordReducers } from '@shared/store/reducers/forgot-password.reducer';

import { authUserInfoReducers } from './auth-user-info.reducers';
import { authReducers } from './auth.reducers';
import { changePasswordReducers } from './change-password.reducer';
import { clientIdReducers } from './client-id.reducers';
import { layoutReducers } from './layout.reducers';
import { managedStoreReducer } from './managed-store.reducers';
import { menuReducers } from './menu.reducers';
import { reportReducer } from '../../../feature/report/stores/reports/reports.reducer';
import { AppStates } from '../state/app.state';

export const appReducers: ActionReducerMap<AppStates, any> = {
  auth: authReducers,
  userInfo: authUserInfoReducers,
  clientId: clientIdReducers,
  forceChangePassword: changePasswordReducers,
  forgotPassword: forgotPasswordReducers,
  layout: layoutReducers,
  menus: menuReducers,
  report: reportReducer,
  managedStore: managedStoreReducer
};
